import Marquee from "react-fast-marquee";

const DEFAULT = [
  "WEBSITE DEVELOPMENT",
  "SOFTWARE ENGINEERING",
  "GEN AI TRAININGS",
  "DIGITAL MARKETING",
  "CLOUD & DEVOPS",
];

export default function EditorialMarquee({ items = DEFAULT, speed = 32 }) {
  return (
    <div
      className="border-y border-white/10 bg-black py-8 md:py-10 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl uppercase tracking-tight text-white/90 px-16">
              {item}
            </span>
            <span className="text-[color:var(--accent)] text-3xl md:text-5xl">*</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
